import React from 'react';
import { Row, Col } from 'antd';
import { PageHeader } from '../layout/PageHeader';
import { RouteComponentProps, Route } from 'react-router-dom';
import { AddBankAccount } from './AddBankAccount';
import i18n from 'i18next';

export const BankList: React.FC = () => {
  return <div>TO DO BANK LIST HERE</div>;
};

export const BankAccount: React.FC<RouteComponentProps> = props => {
  const { match } = props;
  return (
    <div className="bank-account-container">
      <PageHeader headerTitle={i18n.t('BANK_ACCOUNT')} />
      <Row className="bank-container">
        <Col
          xs={24}
          sm={24}
          md={14}
          lg={10}
          xl={10}
          className="bank-account-wrapper"
        >
          <Route exact path={`${match.url}`} component={BankList} />
          <Route path={`${match.url}/add`} component={AddBankAccount} />
        </Col>
      </Row>
    </div>
  );
};
